import React from 'react';
import './LandingPage.css';

function Landing(){

    return (
        <div>        
        {/* // Home */}
        <div>
            <div className='home-screen'>
                <button className='home-button'></button>
            </div>
        </div>
            <div className="letter-fade-in">
            {'CRP NOCTEM'.split('').map((char, index) => (
                <span key={index} style={{ animationDelay: `${index * 0.1}s` }}>
                {char === ' ' ? '\u00A0' : char}
                </span>
            ))}
            </div>
        </div>        
        
    );
}

export default Landing;